import Vue from "vue";

import FormAdd from "@/components/dynamicForms/Add.vue";
import FormEdit from "@/components/dynamicForms/Edit.vue";
import AppInput from "@/components/core/AppInput.vue";
import AppInputFile from "@/components/core/AppInputFile.vue";
import AppInputVideo from "@/components/core/AppInputVideo.vue";
import AppInputImage from "@/components/core/AppInputImage.vue";
import AppInputImageTrans from "@/components/core/AppInputImageTrans.vue";
import AppInputImageCrop from "@/components/core/AppInputImageCrop.vue";
import AppEditor from "@/components/core/AppEditor.vue";
import AppEditor1 from "@/components/core/AppEditor1.vue";
import AppCheckbox from "@/components/core/AppCheckbox.vue";
import AppInputSelect from "@/components/core/AppInputSelect.vue";
import AppTextarea from "@/components/core/AppTextarea.vue";
import AppFeatures from "@/components/core/AppFeatures.vue";
import AppStats from "@/components/core/AppStats.vue";
import MediaModal from "@/components/Modals/MediaModal.vue";

Vue.component("media-modal", MediaModal);
Vue.component("form-add", FormAdd);
Vue.component("form-edit", FormEdit);
Vue.component("app-input-file", AppInputFile);
Vue.component("app-input-video", AppInputVideo);
Vue.component("app-input-image", AppInputImage);
Vue.component("app-input-image-trans", AppInputImageTrans);
Vue.component("app-input-image-crop", AppInputImageCrop);
Vue.component("app-input", AppInput);
Vue.component("app-input-select", AppInputSelect);
Vue.component("app-text-editor", AppEditor);
Vue.component("app-text-editor1", AppEditor1);
Vue.component("app-textarea", AppTextarea);
Vue.component("app-features", AppFeatures);
Vue.component("app-stats", AppStats);
Vue.component("app-checkbox", AppCheckbox);
